import { createAction } from 'redux-actions';

export const forgotPasswordAction = createAction('REQUEST/POST_FORGOT_PASSWORD');
export const resetPasswordAction = createAction('REQUEST/POST_RESET_PASSWORD');
export const changePasswordAction = createAction('REQUEST/POST_CHANGE_PASSWORD');
export const signupRoleAction = createAction('SIGN_UP/SET_ROLE');
